import type { RouteLocationNamedRaw } from 'vue-router'

import { Country } from '@backmarket/http-api'
import { MarketCountryCode } from '@backmarket/http-api/src/api-models/MarketCountryCode'

export const PRESS_LINKS_BY_COUNTRY: Partial<
  Record<MarketCountryCode, RouteLocationNamedRaw>
> = {
  // The press page exists and is linked from the carousel only in Japan
  [Country.JP]: {
    name: 'event-page',
    params: { pageName: 'press', locale: 'ja-jp' },
  },
}
